import { useCallback, useEffect, useState } from 'react';
import useGTM from '@elgorditosalsero/react-gtm-hook';

const useGtmEventTracking = () => {
  const { init, sendDataToGTM } = useGTM();
  const [gtmInitialised, setGtmInitialised] = useState(false);

  useEffect(() => {
    const id = process.env.REACT_APP_GTM_ID;
    const dataLayerName = process.env.REACT_APP_GTM_DATA_LAYER_NAME;

    console.log('GTM Hook Init - ID:', id, 'DataLayer:', dataLayerName);

    if (!id || !dataLayerName) {
      console.error('GTM_ID or GTM_DATA_LAYER_NAME is not defined');
      return;
    }

    init({
      id: id,
      dataLayerName: dataLayerName,
    });
    setGtmInitialised(true);
    console.log('GTM initialized successfully');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [init, gtmInitialised]);

  return useCallback(
    (event: any) => {
      console.log('GTM Event Called:', event, 'Initialized:', gtmInitialised);
      if (gtmInitialised) {
        sendDataToGTM(event);
        console.log('Event sent to GTM:', event);
      } else {
        console.warn('GTM not initialized yet, event not sent:', event);
      }
    },
    [gtmInitialised, sendDataToGTM],
  );
};

export default useGtmEventTracking;
